import { FirstTimeOnboardingState } from '@pages/first-time-onboarding/store/state/first-time-onboarding.state';
import { InviteUserState } from '@pages/first-time-onboarding/store/state/invite-user.state';

export const firstTimeOnboardingStates = [FirstTimeOnboardingState, InviteUserState];
